

class DragItem {

    constructor() {
        this.IMG_TYPE = 0
        this.TXT_TYPE = 1

        this.dragTxt = "";
        this.dragViewTxt = ""
        this.dragIndex = -1
        this.dragItemType = this.TXT_TYPE
        this.dragImgUrl = ""
    }


    getAsJson = () => {
        let obj = {}
        obj.dragTxt = this.dragTxt
        obj.dragViewTxt = this.dragViewTxt
        obj.dragIndex = this.dragIndex
        obj.dragImgUrl = this.dragImgUrl
        obj.dragItemType = this.dragItemType

        return obj
    }


    initFromJson = (obj) => {
        this.dragTxt = obj.dragTxt
        this.dragViewTxt = obj.dragViewTxt
        this.dragIndex = obj.dragIndex
        this.dragImgUrl = obj.dragImgUrl
        this.dragItemType = obj.dragItemType
    }

    getReportAsJson = () => {
        let obj = {}


        return this.getAsJson()
    }
}

export default DragItem